import { AsyncPipe, NgIf } from '@angular/common';
import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ActivityLocationPageComponent } from '@curbnturf/activity-component/src/lib/activity-location-page/activity-location-page.component';
import { AddActivityFormComponent } from '@curbnturf/activity-component/src/lib/add-activity-form/add-activity-form.component';
import { ActivityLocationFacade } from '@curbnturf/activity/src/lib/+state/activity.facade';
import { ActivityLocation } from '@curbnturf/entities';
import { IonicModule, NavController } from '@ionic/angular';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'curbnturf-activity-page',
  templateUrl: './activity-page.component.html',
  styleUrls: ['./activity-page.component.scss'],
  standalone: true,
  imports: [
    ActivityLocationPageComponent,
    forwardRef(() => AddActivityFormComponent),
    AsyncPipe,
    IonicModule,
    NgIf,
    RouterModule,
  ],
})
export class ActivityPageComponent implements OnDestroy, OnInit {
  selectedActivity$?: Observable<ActivityLocation | undefined>;

  add = false;

  private subscriptions: Subscription[] = [];

  constructor(
    private activityLocationFacade: ActivityLocationFacade,
    private navController: NavController,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.selectedActivity$ = this.activityLocationFacade.selected$;
    this.subscriptions.push(
      this.route.params.subscribe((params) => {
        if (params.id === 'add') {
          this.add = true;
        } else {
          this.add = false;
          const id = parseInt(params.id, 10);
          this.activityLocationFacade.load(id);
        }
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  saved() {
    this.navController.navigateForward(['', 'search']);
  }
}
